export default __webpack_public_path__ + "static/media/suhani_shah.e5954dc9.jpeg";